import React from 'react'
import UserStep from '../steps/userStep'
import * as yup from "yup"
import VisitDate from '../steps/visitDate'
import Booked from '../utils/booked'
import { split } from 'lodash'
import Axios from 'axios'
import { sendDataToWebToLead } from '../utils/salesForce'

export const visitStep = [
  {
    schema: yup.object().shape({
      date: yup.date().required(),
      time: yup.string().required()
    }),
    names: ['date', 'time'],
    form: (props) => <VisitDate {...props} />
  },
  {
    schema: yup.object().shape({
      name: yup.string().required(),
      surname: yup.string().required(),
      email: yup.string().required(),
      phone: yup.string().required()
    }),
    name: 'user',
    form: (props) => <UserStep {...props} />,
    handleOnSubmit: async (data, { t, property }) => {
      try {
        if (data.code) {
          const { data: response } = await Axios.post(`${process.env.REACT_APP_API}/user/verifymobilecode`, {
            phone_no: data.phone.replace(/ /g, ''),
            country_code: split(data.phone, ' ')[0],
            verify_code: data.code
          })
        }
        await Axios.post(`${process.env.REACT_APP_API}/property/addVisit/${property.id}`, data)
        const res = await sendDataToWebToLead({
          bookingValues: data,
          property
        })
        if (res.error) {
          return {
            error: true,
            message: 'salesForce.error'
          }
        }
        return {
          error: false
        }
      } catch (e) {
        console.log(e)
        return {
          error: true,
          message: 'number.numberNotVerified'
        }
      }
    }
  },
  {
    finished: true,
    content: (props) => <Booked {...props} />
  }
]